import React from 'react';
interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  const isChunk =
    error.name === 'ChunkLoadError' ||
    /Loading chunk .* failed/.test(error.message);

  return (
    <>
      {(
        !sessionStorage.getItem('refreshed') && isChunk &&
        (sessionStorage.setItem('refreshed', 'true'),
        window.location.reload())
      )}
    </>
  );
};